import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";

function PrivateRoute({ component: Component, roles, ...rest }) {
  const { center } = useSelector((state) => state);
  const { loading, isAuth } = center.centerAuth;
  return (
    <Route
      {...rest}
      render={(props) =>
        !loading && isAuth ? (
          <Component {...rest} {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/center/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
